export default __webpack_public_path__ + "static/media/yo_2.f9c35344.mp3";